import { render } from "./NavTab.vue?vue&type=template&id=69365768&scoped=true&ts=true&lang=html"
import script from "./NavTab.vue?vue&type=script&lang=ts"
export * from "./NavTab.vue?vue&type=script&lang=ts"

import "./NavTab.vue?vue&type=style&index=0&id=69365768&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69365768"]])

export default __exports__